// extracted by mini-css-extract-plugin
module.exports = {"inner":"EditorFooter_inner__2n34j","errorLogs":"EditorFooter_errorLogs__fgMbJ"};